import {useEffect, useState} from "react";
import api from "../../../services/api";

/**
 * 
 * @param bookId
 * @returns {{tocDatas: *[], totalCnt: number}}
 */
export const useGetTocsWithTablesByBookId = (bookId) => {

    const [tocDatas, setTocDatas] = useState([]);
    const [totalCnt, setTotalCnt] = useState(0);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const getToc = async () => {

            try {
                const response = await api.get(`/get_tocs_with_tables_by_book_id/${bookId}`);

                if (response.status === 200) {
                    const items = response.data.data.map((item) => ({
                        toc_id: item.toc_id,
                        toc_title: item.toc_title,
                        toc_title_ko: item.toc_title_ko,
                        // tables는 배열 안의 배열임
                        tables: item.tables ? item.tables.map(table => ({
                            tableau_id: table.tableau_id,
                            tableau_title: table.tableau_title,
                            tableau_title_ko: table.tableau_title_ko
                        })) : [],
                    }));

                    setTocDatas(items);
                    setTotalCnt(items.length);
                    setIsLoading(false);
                }
            } catch (error) {
                throw new Error('Failed to fetch TOC data');
            }
        };

        getToc();

    }, [bookId]);

    return {tocDatas, totalCnt, isLoading}
}